import { DocumentsPanel } from '@/components/documents/documents-panel';
import { useRendezVousRoomId } from '@/lib/documents/room';

/**
 * Fichiers échangés pendant un rendez-vous (portée `room`, migration 0261) —
 * ceux déposés depuis le chat de la visio comme ceux ajoutés d'ici. Visible des
 * DEUX participants ; l'hôte (le tuteur) peut supprimer le fichier d'un autre.
 *
 * Rien à montrer tant que la salle n'a jamais été ouverte (`null`) : sans salle,
 * il n'existe pas de portée à laquelle rattacher un fichier.
 */
export function RendezVousFiles({
  reservationId,
  isHost,
}: {
  reservationId: string;
  isHost: boolean;
}) {
  const room = useRendezVousRoomId(reservationId);
  if (room.isLoading || !room.data) return null;

  return (
    <section className="border-ink-100 rounded-2xl border bg-white p-4 text-left">
      <h2 className="text-ink-900 text-sm font-bold">Fichiers de la réunion</h2>
      <div className="mt-3">
        <DocumentsPanel
          target={{ kind: 'room', roomId: room.data }}
          canUpload
          isRoomHost={isHost}
          emptyLabel="Aucun fichier partagé pendant ce rendez-vous."
        />
      </div>
    </section>
  );
}
